export default "__VITE_ASSET__BG$uUcQV__"